import { render } from "./WorkspaceMenu.vue?vue&type=template&id=d923b8fa&ts=true"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=ts"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__